import { render, staticRenderFns } from "./MeusTutoresPerfil.vue?vue&type=template&id=84c6a23e&scoped=true&"
import script from "./MeusTutoresPerfil.vue?vue&type=script&lang=js&"
export * from "./MeusTutoresPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c6a23e",
  null
  
)

export default component.exports